/* 🤖 this file was generated by svg-to-ts */
export const DfIconDart16: {
  name: 'dart-16';
  data: string;
} = {
  name: 'dart-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8.99 2.339a2.5 2.5 0 0 0-.652 1.13l-.096.364-.445.257a4 4 0 1 0 2.995 5.196l.451-.26.36.097a2.5 2.5 0 0 0 1.287.003A5.999 5.999 0 0 1 1 8a5.999 5.999 0 0 1 7.99-5.661zm.021 5.67a2 2 0 1 1-.996-1.731L9.792 5.25a.5.5 0 0 0 .233-.305l.256-.967a.5.5 0 0 1 .231-.304l2.222-1.298a.5.5 0 0 1 .723.6l-.381 1.063a.5.5 0 0 0 .381.66l1.132.206a.5.5 0 0 1 .163.923l-2.238 1.31a.5.5 0 0 1-.383.05l-.96-.258a.5.5 0 0 0-.38.05z"/></svg>`
};
